export const autosuggestResultProps = () => ({
  shops: {
    type: Array,
    default: null
  },
  keyWord: {
    type: String,
    default: null
  },
  categories: {
    type: Array,
    default: null
  },
  products: {
    type: Array,
    default: null
  },
  isNational: {
    type: Boolean,
    required: true
  },
  headerLight: {
    type: Boolean,
    required: false,
    default: false
  },
  wordSuggestions: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  }
})

export const autosuggestResultEmits = () => ([
  "fetchSerchResults",
  "selectWordSuggestion"
])

export const useAutosuggestResult = (props, emit) => {
  const thresholdToDisplay = 2
  const fetchSerchResults = () => {
    emit("fetchSerchResults");
  };
  const isSameRoute = (path) => {
    const { fullPath } = useRoute();
    return fullPath === path
  };
  const redirectToRecherche = () => {
    const router = useRouter();
    if (props.keyWord) {
      if (isSameRoute('/recherche?keywords=' + props.keyWord)) {
        router.go()
      }
      navigateToInternal({
        path: "/recherche",
        query: { keywords: props.keyWord }
      });
    }
  };

  return { thresholdToDisplay, fetchSerchResults, redirectToRecherche, isSameRoute };
}